<template>
    <router-link class="dashbord-galary__item page-tab" :to="tabData.route"><i :class="tabData.icon"></i> {{tabData.title}}</router-link>
</template>

<script>
export default {
    props:{
        tabData:Object,
    }
}
</script>

<style lang="scss">
.nav-menu{
    .page-tab{
        display: flex;
        justify-content: center;
        padding: 20px;
        border-radius: 20px 0 20px 0;
        cursor: pointer;
        transition-property: background-color;
        transition-duration: 0.3s;
        &:hover{
            background-color: $light-border-clr ;
        }
        .fas,
        .far{
            display: block;
            margin-right: 20px;
            font-size: 18px;
            color: $secondary-text-clr;
        }
    }
}
    
</style>